<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="pi"></a><a class="page" id="pii"></a><a class="page" id="piii"></a>Feasting and Fasting</h1>
<h1 class="bk1">The History and Ethics of Jewish Food</h1>
<p class="bkau">Edited by Aaron S. Gross, Jody Myers, and Jordan D. Rosenblum</p>
<p class="bkau1">With a Foreword by Hasia R. Diner and an Afterword by Jonathan Safran Foer</p>
<p class="bkpub"><img alt="" height="50" src="images/nyu-logo.jpg" width="42"/></p>
<p class="bkpub">NEW YORK UNIVERSITY PRESS</p>
<p class="bkpub1">New York</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nyugross0002.vue?7fa5e806